import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { compose } from "redux";

import connectActions from "fantastic/lib/connectActions";
import loadCollections from "fantastic/actions/loadCollections";

import Entity from "./Entity";
import EntityEmpty from "./EntityEmpty";

const CollectionEntity = ({ id, type, name, elements }) => {
  return (
    <div className="fantastic-elements">
      {name && <div className="fantastic-elements__header">{name}</div>}
      {elements ? (
        elements.map((element, index) => <Entity key={index} {...element} />)
      ) : (
        <EntityEmpty id={id} type={type} />
      )}
    </div>
  );
};

export default CollectionEntity;
